// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer___2sOKM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modals/SignUpModal/SignUpModal.scss
// module id = IRS6
// module chunks = 46